import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class CustomMatPaginator extends MatPaginatorIntl {

  override itemsPerPageLabel = 'Itens por página';
  override firstPageLabel = 'Primeira página';
  override previousPageLabel = 'Página anterior';
  override nextPageLabel = 'Próxima página';
  override lastPageLabel = 'Última página';

  override getRangeLabel = function (page: number, pageSize: number, length: number) {

    if (length === 0 || pageSize === 0) {
      return 'Mostrando 0 de ' + length;
    }

    length = Math.max(length, 0);
    let startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
      startIndex = startIndex + 1;
    return 'Mostrando ' + startIndex + ' a ' + endIndex + ' de ' + length;
  };
}
